export const HEALTH_TEXT_LIMITS = Object.freeze({
  short: 160,
  medium: 600,
  long: 2000,
});

const LONG_FIELDS = new Set([
  "note",
  "avoid",
  "medicines",
  "criticalAllergies",
  "criticalConditions",
  "criticalMedicines",
  "resultSummary",
  "chronicDiseases",
  "allergies",
  "regularMedicines",
  "surgeries",
  "specialCondition",
  "healthNote",
  "notes",
]);

const MEDIUM_FIELDS = new Set([
  "location",
  "symptoms",
  "action",
  "doctor",
  "institution",
  "followUp",
  "preferredHospital",
]);

export const healthTextLimitForField = (field = "") => {
  if (LONG_FIELDS.has(field)) return HEALTH_TEXT_LIMITS.long;
  if (MEDIUM_FIELDS.has(field)) return HEALTH_TEXT_LIMITS.medium;
  return HEALTH_TEXT_LIMITS.short;
};

export const limitHealthText = (field, value) => {
  if (typeof value !== "string") return value;
  const characters = Array.from(value);
  const limit = healthTextLimitForField(field);
  return characters.length > limit ? characters.slice(0, limit).join("") : value;
};
